import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-up-right",
  "use": "icon-arrow-up-right-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"lucide lucide-arrow-up-right-icon lucide-arrow-up-right\" id=\"icon-arrow-up-right\"><path d=\"M7 7h10v10\" /><path d=\"M7 17 17 7\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol